import { type Feature } from "../../common/models/Feature";
import { type Project } from "../../common/models/Project";
import { type Tag } from "../../common/models/Tag";

import * as Subscription from "./Subscription";

export interface Workspace {
    id: string;
    name: string;
    slug: string;
    createdBy: string;
    projects: Project[];
    tags: Tag[];
    subscription: Subscription.Subscription;
    numOfMembers: number;
    numOfComponents: number;
    numOfAnalyses: number;
    numOfRecentAnalyses: number;
    nextAvailableAnalysisDate: Date;
    hasMemberLimitReached: boolean;
    dataRetentionLimitDate?: Date;
    hasReachedDataRetentionLimit: boolean;
    hasReachedTagLimit: boolean;
    componentLimitGracePeriodEndAt?: Date;
    analysisInProgress: boolean;
}

export function isFeatureEnabled(workspace: Workspace | null, feature: Feature) {
    // when there is no subscription, we consider all features as enabled
    return workspace ? Subscription.isFeatureEnabled(workspace.subscription, feature) : true;
}

